import React from 'react';
import './Pmaterialproducts.css';

const Pmaterialproducts = () => {
    return (
        <div className="Material-container">
            <div className='Materialsl'>
                <h2 className="Material-title">PVC Material Products Injection Molding</h2>
                <p className="Material-date">Nov. 10, 2022</p>
                 <p className="Material-text"> Polyvinyl Chloride is widely available 
                    in two categories: rigid and flexible.
                     Each type has its own set of advantages and ideal uses in different industries.</p>
                <p className="Material-date">Flexible PVC</p>
                <p className="Material-text">can be used as cable insulation and as a rubber replacement.</p>
                                <p className="Material-date">Rigid PVC</p>
                <p className="Material-text">has a variety of uses in construction and plumbing, providing 
                    a lightweight, cost-effective and durable material.</p>

            </div>
        </div>
    );
};
export default Pmaterialproducts;
